import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Content, ButtonMenuPerfil, OpcaoButton, AcessoButton, Overlay } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { signOut } from '~/store/modules/auth/actions';
import { changeToken } from '~/store/modules/auth/actions';

import IconModalAcessoSistema from '~/assets/icones/modal/IconModalAcessoSistema.svg';
import IconModalAcessoModulos from '~/assets/icones/modal/IconModalAcessoModulos.svg';
import IconModalAcessoPerfis from '~/assets/icones/modal/IconModalAcessoPerfis.svg';
import IconModalAcessoPerfil from '~/assets/icones/modal/IconModalAcessoPerfil.svg';
import IconModalAcessoSair from '~/assets/icones/modal/IconModalAcessoSair.svg';

export default function Perfil({
  desktop,
  perfilAtivo,
  modulos,
  setComponentPath,
  currentModulo,
  setShowMaxMenu,
}) {
  const dispatch = useDispatch();
  const { usuario, perfis } = useSelector(state => state.auth);
  const [showModal, setShowModal] = useState(false);

  function configAcesso(perfil) {
    dispatch(changeToken(perfil));
  }

  return (
    <>
      <ButtonMenuPerfil desktop={desktop} onClick={() => setShowModal(!showModal)}>
        <div className="circul-perfil">
          <p>{usuario?.nome[0]}</p>
        </div>
      </ButtonMenuPerfil>
      {showModal && (
        <>
          <Overlay isShowMenu={showModal} onClick={() => setShowModal(false)} />
          <Content>
            <CustomScrollBar
              fixScrollMargin
              autoHeightMax="calc(100vh - 7.75em - var(--aviso-novo-portal-altura, 0px))"
            >
              <div className="sec-title">
                <img src={IconModalAcessoPerfis} alt="Perfis" />
                <h5 className="title">Acessos</h5>
              </div>
              {perfis?.map((perfil, index) => (
                <AcessoButton
                  clean
                  key={index}
                  ativo={perfil?.token === perfilAtivo?.token ? 1 : undefined}
                  onClick={e => configAcesso(perfil, e)}
                >
                  <img
                    className="img-acesso"
                    src={require('~/assets/acessos/' +
                      (perfil?.token === perfilAtivo?.token ? 'ativo/' : 'desativo/') +
                      perfil?.icone +
                      '.svg')}
                    alt="Acesso"
                  />
                  <div className="texto-acesso">
                    <h5 title="Empresa ErpWorks">
                      {perfil?.nomeEmpresa} - {perfil?.nomeUnidade}
                    </h5>
                    <h6 title={perfil?.descricaoTipo}>{perfil?.descricaoTipo}</h6>
                  </div>
                </AcessoButton>
              ))}
              <span className="margin-top" />
              <div className="sec-title">
                <img src={IconModalAcessoModulos} alt="Módulos" />
                <h5 className="title">Módulos</h5>
              </div>
              {modulos?.map((modulo, index) => (
                <AcessoButton
                  clean
                  key={index}
                  ativo={currentModulo?.id === modulo?.id ? 1 : undefined}
                  onClick={() => {
                    let thisModulo = modulo;
                    let thisMenu = thisModulo?.menus?.[0];

                    if (!thisMenu.possuiSubMenu) {
                      setComponentPath({
                        moduloPath: thisModulo?.path,
                        menuPath: thisMenu?.path,
                        subMenuPath: false,
                      });
                    } else {
                      let thisSubMenu = thisMenu?.subMenus?.[0];
                      setComponentPath({
                        moduloPath: thisModulo?.path,
                        menuPath: thisMenu?.path,
                        subMenuPath: thisSubMenu?.path,
                      });
                    }
                    setShowMaxMenu(true);
                  }}
                >
                  <img
                    className="img-acesso"
                    src={require('~/assets/modulos/' +
                      (currentModulo?.id === modulo?.id ? 'ativo/' : 'desativo/') +
                      modulo?.icone +
                      '.svg')}
                    alt="Acesso"
                  />
                  <div className="texto-acesso">
                    <h5 title="Descrição">Módulo</h5>
                    <h6 title="Empresa Gestor">{modulo?.nome}</h6>
                  </div>
                </AcessoButton>
              ))}
              <span className="margin-top" />
              <div className="sec-title">
                <img src={IconModalAcessoSistema} alt="Sistema" />
                <h5 className="title">Sistema</h5>
              </div>
              <OpcaoButton
                onClick={() => {
                  setComponentPath({
                    moduloPath: 'Administracao',
                    menuPath: 'Perfil',
                    subMenuPath: false,
                  });

                  setShowMaxMenu(true);
                }}
              >
                <img src={IconModalAcessoPerfil} alt="Atualizar Dados" />
                <div className="texto-acesso">
                  <h6>Perfil</h6>
                </div>
              </OpcaoButton>
              <OpcaoButton onClick={() => dispatch(signOut())}>
                <img src={IconModalAcessoSair} alt="Sair" />
                <div className="texto-acesso">
                  <h6>Sair</h6>
                </div>
              </OpcaoButton>
            </CustomScrollBar>
          </Content>
        </>
      )}
    </>
  );
}
